import { Heading, Text } from "@imagedesignai/neo";
import {
  GENERATION_SETTINGS_FIELDS,
  type GenerationSettings,
} from "../../src/generation-settings.ts";

function settingValue(value: GenerationSettings[keyof GenerationSettings]): string {
  if (typeof value === "boolean") return value ? "Enabled" : "Disabled";
  if (value === "") return "Not set";
  return String(value);
}

export function GenerationSettingsView({
  contractVersion,
  settings,
}: {
  contractVersion: 1;
  settings: GenerationSettings;
}) {
  return (
    <section className="generation-settings-detail" aria-label="Generation settings">
      <Heading level={2} scale="sm">
        Generation settings
      </Heading>
      <Text kind="caption" tone="muted">
        Effective immutable settings · contract {contractVersion}
      </Text>
      <dl className="generation-settings-grid">
        {GENERATION_SETTINGS_FIELDS.map(({ name, label }) => (
          <div key={name} className="generation-setting-row">
            <dt>{label}</dt>
            <dd className="mono">{settingValue(settings[name])}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
